const triggerValidateEmail = (email,sessionId, clientIp) => {
    const body = {
        "email": email,
        "security": {
            "session": {
                "id": sessionId
            },
            "client_ip": clientIp,
            "version": "3"
        }
    }

    const requestOptions = {
        method: "POST",
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        body: JSON.stringify(body)
    };
    return fetchApiWu(`/wudgtsrvs/mobiliser/rest/channel/GwpValidateEmail?timestamp=${new Date().getTime()}`,requestOptions, "GwpValidateEmail")
  }